var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldLikeTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C4.34 2 3 3.33 3 4.97v10.91c0 1.64 1.34 2.97 3 2.97h.76c.8 0 1.56.31 2.12.87l1.71 1.69c.78.77 2.05.77 2.83 0l1.71-1.69c.56-.56 1.33-.87 2.12-.87H18c1.66 0 3-1.33 3-2.97V4.97C21 3.33 19.66 2 18 2H6zm9.51 12.06c-.15.59-.78 1.07-1.42 1.07h-1.85c-.32 0-.77-.11-.97-.31L9.8 13.67c-.03.64-.32.91-1.03.91h-.48c-.74 0-1.04-.29-1.04-.99V8.82c0-.7.3-.99 1.04-.99h.49c.74 0 1.04.29 1.04.99v.36l1.94-2.88c.2-.31.71-.53 1.14-.36.47.16.77.68.67 1.14l-.24 1.56c-.03.13 0 .27.09.36.08.09.2.15.33.15h1.95c.38 0 .7.15.89.42.18.26.21.59.09.93l-1.17 3.56z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldLikeTag);
export default __webpack_public_path__ + "static/media/vuesax-bold-like-tag.bad87f88c281c03aa21e61a325d72667.svg";
export { ForwardRef as ReactComponent };